module.exports = __webpack_public_path__ + "static/img/020_6.dee11d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_6.jpg
// module id = 62hw
// module chunks = 1